module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/cost-o30-a49557f45d10ca6234bc66d17e8b8229.svg";